import { efficiencyYBIFinishedValidate } from "../../application/dtos/efficiency_ybi_finished_validate";

export class efficiencyYBIFinishedEntity {
    constructor( data ){ // cuando se recive un objeto con propiedades indefinidas en vez de las propiedades definidad de un objeto
        this.data = data
    }

    isValid() {
        return efficiencyYBIFinishedValidate(this);
    }
}